export default __webpack_public_path__ + "static/media/My project.b54608a1.jpg";